var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-navigation-drawer",
        {
          staticClass: "sidebar",
          class: {
            "auto-height":
              _vm.$lowResolution && !_vm.$store.getters.leftSideBarPinned,
            "full-height": _vm.$store.getters.leftSideBarPinned
          },
          attrs: {
            touchless: "",
            app: "",
            clipped: "",
            stateless: "",
            "hide-overlay": "",
            "disable-resize-watcher": "",
            width: _vm.$mdAndUpResolution
              ? _vm.$store.getters.sidebarFullWidth
              : _vm.$store.getters.sidebarShrunkWidth,
            permanent: _vm.$store.getters.leftSideBarPinned
          },
          model: {
            value: _vm.isSideBarOpen,
            callback: function($$v) {
              _vm.isSideBarOpen = $$v
            },
            expression: "isSideBarOpen"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "sidebar-header",
              style: { height: _vm.$store.getters.sidebarHeaderHeight + "px" }
            },
            [
              _c(
                "v-layout",
                { staticClass: "sidebar-header-top", attrs: { row: "" } },
                [
                  _c("v-flex", { attrs: { xs6: "", md9: "" } }, [
                    _c("div", { staticClass: "logo-container" }, [
                      _c("a", { attrs: { href: _vm.homeUrl } }, [
                        _c("img", {
                          staticClass: "medium ml-2",
                          attrs: {
                            height: "52.5",
                            src: _vm.getImgSrc("logoImgSrc"),
                            title: _vm.getConfigVal("appName"),
                            alt: _vm.getConfigVal("appName")
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "sidebar-top-menu",
                      attrs: { xs6: "", md3: "" }
                    },
                    [_c("top-menu")],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sidebar-content",
              style: { height: _vm.sidebarContentHeightFormula }
            },
            [
              _c(
                "div",
                {
                  staticClass: "sidebar-content-form",
                  style: {
                    "padding-bottom": _vm.$store.getters.footerHeight + "px"
                  }
                },
                [
                  _vm.$store.getters.mapReady
                    ? _c("map-form", { staticClass: "map-search" })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$highResolution
                    ? _c(
                        "v-expansion-panel",
                        { attrs: { value: null } },
                        [
                          _c(
                            "v-expansion-panel-content",
                            { staticStyle: { background: "transparent" } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "header" }, slot: "header" },
                                [_vm._v("Menu")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list",
                                [
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    { attrs: { dense: "" } },
                                    [
                                      _vm._l(_vm.menuItems, function(
                                        item,
                                        index
                                      ) {
                                        return [
                                          _c("app-v-menu", {
                                            key: index,
                                            attrs: {
                                              item: item,
                                              showIcon: true
                                            }
                                          })
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("app-footer")
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.isSideBarOpen && _vm.$highResolution
        ? _c(
            "v-btn",
            {
              staticClass: "toggle-sidebar",
              class: {
                hidden: !_vm.isSideBarOpen,
                "low-res": _vm.$lowResolution
              },
              attrs: {
                fab: "",
                small: "",
                title: _vm.$t("sidebar.hideSidebar")
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.isSideBarOpen = false
                }
              }
            },
            [
              _c("v-icon", { attrs: { large: "" } }, [
                _vm._v("keyboard_arrow_left ")
              ])
            ],
            1
          )
        : !_vm.isSideBarOpen && !_vm.$lowResolution && !_vm.$store.getters.embed
        ? _c(
            "v-btn",
            {
              staticClass: "toggle-sidebar",
              class: { hidden: !_vm.isSideBarOpen },
              attrs: {
                fab: "",
                small: "",
                title: _vm.$t("sidebar.showSidebar")
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.isSideBarOpen = true
                }
              }
            },
            [
              _c("v-icon", { attrs: { large: "" } }, [
                _vm._v("keyboard_arrow_right ")
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7df40d94", { render: render, staticRenderFns: staticRenderFns })
  }
}